ACPVisualGuidelinesActions = require 'actions/acp_visual_guidelines_actions'
DropdownMenu = require 'components/common/dropdown_menu'
EpiditorWrapper = require 'components/common/epiditor_wrapper'
etdHelper = require 'lib/etd_helper'
GdtEditorWithApply = Editor.EditorWithApply
IconButton = require 'components/common/icon_button'
Select = require 'components/common/select_custom'
Spinner = require 'components/common/spinner'
mediator = require 'mediator'
{ useI18n, useCoffeeCallback } = require 'lib/react_utils'
{ useState, useEffect, useMemo } = React
{ SelectWithCheckboxes } = ReactComponents

veryLowText = ->
  if mediator.services.switches.isServerSwitchOn 'acpFeatures'
    'insufficient'
  else
    'very_low'

mapStrengthOfRecommendation = (strength) ->
  if ['strong_for', 'conditional_for', 'either', 'conditional_against', 'strong_against'].includes(strength)
    return strength
  if mediator.services.switches.isServerSwitchOn 'acpFeatures'
    switch strength
      when 'recommend', 'recommend_against' then 'strong'
      when 'suggest_against', 'suggest_either', 'suggest' then 'conditional'
      else ''
  else
    switch strength
      when 'recommend_against' then 'strong_against'
      when 'recommend' then 'strong_for'
      when 'suggest' then 'conditional_for'
      when 'suggest_against' then 'conditional_against'
      when 'either' then 'either'
      else ''

RecommendationContent = ({
  populationId
  recommendation
  recommendationId
  section
  typeOfRecommendation
}) ->
  i18n = useI18n('')
  sectionId = section.get('_id')

  recommendationData = useMemo () ->
    section.getIn(['additionalData', 'recommendationsData', recommendationId], Immutable.Map())
  , [section, recommendationId]

  recommendationContent = useMemo () ->
    recommendationData.get('content') or recommendation.get('content')
  , [recommendationData, recommendation]

  rationale = useMemo () ->
    recommendationData.get('rationale') # we don't have it in EtD yet
  , [recommendationData]
  certaintyTagText = recommendationData.get('certaintyTagText') # we don't have it in EtD yet

  [tagText, setTagText] = useState(certaintyTagText)

  useEffect ->
    setTagText(certaintyTagText)
  , [ certaintyTagText ]

  certaintyOfEvidence = recommendationData.get('certaintyOfEvidence', Immutable.List()).toJS()
     # in EtD we have certaintyOfEvidence by intervention

  strengthOfRecommendation = mapStrengthOfRecommendation(
    recommendationData.get('strengthOfRecommendation') or typeOfRecommendation)

  handleSettingSelect = useCoffeeCallback [populationId, sectionId, recommendationId], (setting) ->
    switch setting
      when 'delete'
        groupName = recommendation.get('content')
        confirmOptions =
          title: i18n 'vi:confirm.remove_recommendation.title'
          message: i18n 'vi:confirm.remove_recommendation.message'
          confirmText: i18n '/actions.delete'
          declineText: i18n '/actions.cancel'
          yesClass: 'danger'
        mediator.dialogs.confirm confirmOptions, (confirmed) ->
          return unless confirmed
          ACPVisualGuidelinesActions.removeRecommendation(
            { populationId, sectionId, recommendationId }
          )

  onChangeRecommendationData = useCoffeeCallback [sectionId, recommendationId], (key) -> (value) ->
    ACPVisualGuidelinesActions.updateRecommendationData(
      { sectionId, recommendationId, key, value }
    )

  saveContent = useCoffeeCallback [sectionId, recommendationId], (key, value) -> ->
    ACPVisualGuidelinesActions.updateRecommendationData(
      {
        sectionId
        recommendationId
        key
        value
      }
    )

  <div className="recommendation-content">
    <div className="flex flex-row">
      <div className="flex-grow text-right">
        <DropdownMenu
          opener={(
            <IconButton iconName="more" className="settings-toggle" />
          )}
          options={[
            { text: i18n('vi:form.settings.delete'), value: 'delete'}
          ]}
          onSelect={handleSettingSelect}
        />
      </div>
    </div>
    <div className="flex flex-row">
      <div className="flex-grow">
        <div className="mb-5">
          <h3>{i18n 'vi:recommendation'}</h3>
          <div className="recommendation-content__text-field">
            <DraftToEpiditorSwap
              content={recommendationContent}
              editorKey="content"
              readOnly={false}
              sectionId={sectionId}
              recommendationId={recommendationId}
            />
          </div>
        </div>
        <div className="mb-5">
          <h3>{i18n 'vi:rationale'}</h3>
          <div className="recommendation-content__text-field">
            <DraftToEpiditorSwap
              content={rationale}
              editorKey="rationale"
              readOnly={false}
              sectionId={sectionId}
              recommendationId={recommendationId}
            />
          </div>
        </div>
      </div>
      <div className="ml-20 additional-options">
        <h3>{i18n 'vi:form.strength_of_recommendation'}</h3>
        <Select
          name="strengthOfRecommendation"
          className="w-full"
          onChange={onChangeRecommendationData('strengthOfRecommendation')}
          selected={strengthOfRecommendation}
          options={[
            { text: i18n('vi:form.strength.strong_for'), value: 'strong_for'}
            { text: i18n('vi:form.strength.conditional_for'), value: 'conditional_for'}
            { text: i18n('vi:form.strength.either'), value: 'either'}
            { text: i18n('vi:form.strength.conditional_against'), value: 'conditional_against'}
            { text: i18n('vi:form.strength.strong_against'), value: 'strong_against'}
          ]}
        />
        <h3>{i18n 'vi:form.certainty_title'}</h3>
        <SelectWithCheckboxes
          name="certaintyOfEvidence"
          className="w-full"
          onChange={onChangeRecommendationData('certaintyOfEvidence')}
          selectedOptions={certaintyOfEvidence}
          withSelectAll={false}
          options={[
            { text: i18n("vi:form.certainty.#{veryLowText()}"), value: 'very_low'}
            { text: i18n('vi:form.certainty.low'), value: 'low'}
            { text: i18n('vi:form.certainty.moderate'), value: 'moderate'}
            { text: i18n('vi:form.certainty.high'), value: 'high'}
          ]}
        />
        <h3>{i18n 'vi:form.certainty_label'}</h3>
        <input
          type="text"
          className="w-full"
          value={tagText or ''}
          onChange={(e) -> setTagText(e.target.value)}
          onBlur={saveContent('certaintyTagText', tagText)}
        />
      </div>
    </div>
  </div>

RecommendationContent.propTypes = {
  populationId: PropTypes.string.isRequired
  recommendation: PropTypes.instanceOf(Immutable.Map)
  recommendationId: PropTypes.string.isRequired
  section: PropTypes.instanceOf(Immutable.Map).isRequired
  strengthOfRecommendation: PropTypes.string
}

RecommendationContent.defaultProps = {
  recommendation: Immutable.Map()
  strengthOfRecommendation: null
}

DraftToEpiditorSwap = ({ content, editorKey, readOnly, sectionId, recommendationId }) ->
  saveContent = useCoffeeCallback [sectionId, recommendationId], (key, value) ->
    ACPVisualGuidelinesActions.updateRecommendationData({
      sectionId
      recommendationId
      key
      value
    })

  <EpiditorWrapper
    content={content}
    onSave={(value) -> saveContent editorKey, value}
    pluginProps={[]}
    readOnly={readOnly}
  />

module.exports = RecommendationContent
